import { render, staticRenderFns } from "./HeaderBody.vue?vue&type=template&id=76894694&scoped=true&"
import script from "./HeaderBody.vue?vue&type=script&lang=ts&"
export * from "./HeaderBody.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBody.vue?vue&type=style&index=0&id=76894694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76894694",
  null
  
)

export default component.exports